import { render, staticRenderFns } from "./ConventionParticipants.vue?vue&type=template&id=4b1755b3&"
import script from "./ConventionParticipants.vue?vue&type=script&lang=js&"
export * from "./ConventionParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1755b3')) {
      api.createRecord('4b1755b3', component.options)
    } else {
      api.reload('4b1755b3', component.options)
    }
    module.hot.accept("./ConventionParticipants.vue?vue&type=template&id=4b1755b3&", function () {
      api.rerender('4b1755b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/ConventionParticipants.vue"
export default component.exports